export enum TargetObjectTypeEnum {
    CustomField = 0,
    Tax = 1,
    SalesTax = 2,
    ProductService = 3,
    ChartOfAccounts = 4,
    BankAccountID = 5
}